var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticClass: "neu-cards-ctn landing-cnt",
          attrs: { cols: "1", "cols-xl": "4" }
        },
        _vm._l(_vm.blocks, function(block) {
          return _c("PatientPanelServiceBlock", {
            key: block.id,
            attrs: {
              id: block.id,
              visible: "",
              title: block.title,
              img: block.img,
              action: block.action,
              soonLabel: block.soonLabel,
              description: block.description,
              enabled: block.enabled,
              backgroundColor: block.backgroundColor,
              textAndIconColor: block.textAndIconColor
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34aafb10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aafb10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/MyApplicationsPanelMenu.vue
// module id = 4205
// module chunks = 85